/**
 * Convertir une date au format ISO8601 en jour, heure et minutes
 * @param dateString la date au format ISO8601
 * @param locale la locale a utiliser
 * @returns {string} le jour, heure et minutes
 */
export const convertDateStringToDayTimeLocaleString = (dateString, locale) => {
  let date = new Date(dateString);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  return date.toLocaleString(locale, options);
};

/**
 * Convertir une date au format ISO8601 en jour
 * Ex : 2024-02-01T10:00:00 => jeudi 1 février 2024 (fr) /  Thursday, February 1, 2024 (en)
 *
 * @param dateString la date au format ISO8601
 * @param locale la locale a utiliser
 * @return {string} le jour
 */
export const convertDateStringToDayLocaleString = (dateString, locale) => {
  let date = new Date(dateString);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return date.toLocaleString(locale, options);
};

/**
 * Convertir une date au format ISO8601 en heure et minutes
 * Ex : 2024-02-01T10:00:00 => 10:00 (fr) /  10:00 AM (en)
 *
 * @param dateString la date au format ISO8601
 * @param locale la locale a utiliser
 * @return {string} l'heure et minutes
 */
export const convertDateStringToTimeLocaleString = (dateString, locale) => {
  let appointmentDate = new Date(dateString);
  const options = { hour: 'numeric', minute: 'numeric' };
  return appointmentDate.toLocaleTimeString(locale, options);
};

/**
 * Convertir un nombre de minutes en heures et minutes.
 * Ex: 40 => 40 min
 * Ex: 60 => 1h
 * Ex: 90 => 1h 30min
 *
 * @param mins le nombre de minutes
 * @return {string} le résultat formaté sous la forme 00h 00min
 */
export const convertMinsToHrsMinsString = (mins) => {
  if (mins < 60) {
    return `${mins}min`;
  }
  let hours = Math.floor(mins / 60);
  let minutes = mins % 60;
  return minutes !== 0 ? `${hours}h ${minutes}min` : `${hours}h`;
};

export const getStartTime = (time, locale) => {
  return convertDateStringToTimeLocaleString(time, locale);
};

export const getEndTime = (time, locale) => {
  time = time.split(':');
  const date = new Date(1900, 1, 1, time[0], time[1], time[2]);
  return convertDateStringToTimeLocaleString(date, locale);
};
